import React, { useEffect, useState } from 'react';
import { HiOutlineUser, HiOutlineMail, HiOutlinePhone, HiOutlineOfficeBuilding, HiOutlineDocumentText, HiOutlineX, HiOutlineEye } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

export default function GuestTekliflerPage() {
  const [offers, setOffers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/guest-offers')
      .then(res => res.json())
      .then(setOffers)
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = async (id) => {
    setSelected(null);
    setLoading(true);
    const res = await fetch(`/api/guest-offers/${id}`);
    const data = await res.json();
    console.log('API Response for offer:', data); // Debug log
    setSelected(data);
    setLoading(false);
  };

  if (loading && !selected) return <div className="flex justify-center items-center h-40 text-blue-700 text-lg font-semibold animate-pulse">Yükleniyor...</div>;

  return (
    <div className="p-6 w-full">
      <h1 className="text-3xl font-bold mb-8 text-blue-900 flex items-center gap-3 px-6 pt-6">
        <HiOutlineDocumentText className="w-8 h-8 text-blue-700" /> Misafir Teklifler
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {offers && offers.length > 0 ? offers.map(offer => (
          <div key={offer.id} className="bg-white rounded-2xl shadow-lg border border-blue-100 p-5 flex flex-col gap-3 hover:shadow-2xl transition cursor-pointer relative group" onClick={() => handleSelect(offer.id)}>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 text-xl font-bold">
                <HiOutlineUser className="w-7 h-7" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-blue-900 text-lg">{offer.firma}</span>
                <span className="text-blue-700 text-sm">{offer.yetkili}</span>
              </div>
              <span className="ml-auto text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full font-semibold">#{offer.id}</span>
            </div>
            <div className="flex flex-wrap gap-2 text-xs text-blue-800">
              <span className="flex items-center gap-1 bg-blue-50 px-2 py-1 rounded"><HiOutlinePhone className="w-4 h-4" /> {offer.telefon}</span>
              <span className="flex items-center gap-1 bg-blue-50 px-2 py-1 rounded"><HiOutlineMail className="w-4 h-4" /> {offer.email}</span>
              <span className="flex items-center gap-1 bg-blue-50 px-2 py-1 rounded"><HiOutlineOfficeBuilding className="w-4 h-4" /> {offer.sehir}</span>
              <span className="flex items-center gap-1 bg-blue-50 px-2 py-1 rounded">{new Date(offer.created_at).toLocaleDateString()}</span>
            </div>
            <button className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition bg-blue-700 text-white rounded-full p-2 shadow-lg" onClick={e => {e.stopPropagation(); handleSelect(offer.id);}} title="Detayları Gör"><HiOutlineEye className="w-5 h-5" /></button>
          </div>
        )) : (
          <div className="col-span-full text-center text-blue-700 text-lg py-12">
            {loading ? 'Yükleniyor...' : 'Henüz teklif bulunmuyor.'}
          </div>
        )}
      </div>
      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-2xl flex flex-col gap-6 border border-blue-100 relative animate-fade-in">
            <button className="absolute top-4 right-4 text-blue-900 text-2xl font-bold hover:text-red-600" onClick={() => setSelected(null)}><HiOutlineX /></button>
            <h2 className="text-2xl font-bold mb-2 text-blue-900 flex items-center gap-2"><HiOutlineDocumentText className="w-7 h-7 text-blue-700" /> Teklif Detayı <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full font-semibold">ID: {selected.id}</span></h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-blue-50 rounded-xl p-4 flex flex-col gap-1">
                <div className="text-blue-900 font-semibold mb-1">Firma Bilgileri</div>
                <div className="flex items-center gap-2 text-sm"><HiOutlineOfficeBuilding className="w-5 h-5" /> <b>{selected.firma?.firma || selected.firma}</b></div>
                <div className="flex items-center gap-2 text-sm"><HiOutlineUser className="w-5 h-5" /> <b>{selected.firma?.yetkili || selected.yetkili}</b></div>
                <div className="flex items-center gap-2 text-sm"><HiOutlinePhone className="w-5 h-5" /> <b>{selected.firma?.telefon || selected.telefon}</b></div>
                <div className="flex items-center gap-2 text-sm"><HiOutlineMail className="w-5 h-5" /> <b>{selected.firma?.email || selected.email}</b></div>
                <div className="flex items-center gap-2 text-sm"><span className="font-bold">Adres:</span> <span>{selected.firma?.adres || selected.adres}</span></div>
                <div className="flex items-center gap-2 text-sm"><span className="font-bold">Şehir:</span> <span>{selected.firma?.sehir || selected.sehir}</span></div>
                <div className="flex items-center gap-2 text-sm"><span className="font-bold">Vergi Dairesi:</span> <span>{selected.firma?.vergiDairesi || selected.vergiDairesi}</span></div>
                <div className="flex items-center gap-2 text-sm"><span className="font-bold">Vergi No:</span> <span>{selected.firma?.vergiNo || selected.vergiNo}</span></div>
                <div className="flex items-center gap-2 text-sm"><span className="font-bold">Tarih:</span> <span>{new Date(selected.firma?.created_at || selected.created_at).toLocaleString()}</span></div>
              </div>
              <div className="bg-blue-50 rounded-xl p-4 flex flex-col gap-1">
                <div className="text-blue-900 font-semibold mb-1">Ürünler</div>
                <div className="max-h-56 overflow-y-auto">
                  <table className="min-w-full border text-xs">
                    <thead>
                      <tr>
                        <th className="border px-2 py-1">Ürün Adı</th>
                        <th className="border px-2 py-1">Ölçü</th>
                        <th className="border px-2 py-1">Adet</th>
                        <th className="border px-2 py-1">Açıklama</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selected.items && selected.items.length > 0 ? selected.items.map(item => (
                        <tr key={item.id}>
                          <td className="border px-2 py-1 font-semibold text-blue-900">{item.name}</td>
                          <td className="border px-2 py-1"><span className="bg-blue-200 text-blue-900 px-2 py-0.5 rounded-full font-semibold">{item.measure}</span></td>
                          <td className="border px-2 py-1">{item.qty}</td>
                          <td className="border px-2 py-1">{item.aciklama}</td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="4" className="border px-2 py-1 text-center text-gray-500">Ürün bulunamadı</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button className="px-4 py-2 rounded bg-blue-700 text-white font-semibold hover:bg-blue-800 transition" onClick={() => {
                console.log('Selected offer data:', selected); // Debug log
                if (selected && selected.id) {
                  console.log('Navigating to:', `/admin/teklif-degerlendir/${selected.id}`);
                  navigate(`/admin/teklif-degerlendir/${selected.id}`);
                } else {
                  console.error('Selected offer data:', selected);
                  alert('Teklif ID bulunamadı! Lütfen tekrar deneyin.');
                }
              }}>
                Teklifi Değerlendir
              </button>
              <button className="px-4 py-2 rounded bg-gray-200 text-blue-900 font-semibold hover:bg-gray-300 transition" onClick={() => setSelected(null)}>
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 